import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/layout'
import memberManagerRoutes from "@/router/modules/memberManager";
import voucherManagerRoutes from "@/router/modules/voucherManager";
//import testManagerRoutes from "@/router/modules/test";

export const asyncRoutes = []

export const constantRoutes = [
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [{
            path: '/redirect/:path(.*)',
            component: () =>
                import ('@/views/redirect/index')
        }]
    },
    {
        path: '/login',
        component: () =>
            import ('@/views/login/index'),
        hidden: true
    },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [{
            path: 'dashboard',
            name: 'Dashboard',
            component: () => import ('@/views/dashboard/index'),
            meta: {
                title: '首页',
                icon: 'dashboard',
                affix: true
            }
        }]
    },
    {
        path: '/404',
        component: () =>
            import ('@/views/error-page/404'),
        hidden: true
    },
    {
        path: '/401',
        component: () =>
            import ('@/views/error-page/401'),
        hidden: true
    }
    ,
     ...memberManagerRoutes,
     ...voucherManagerRoutes,
     //...testManagerRoutes

]


const createRouter = () => new Router({
    // mode: 'history',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: constantRoutes
})
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

const router = createRouter()
export default router
